import SettingsContent, { SettingsContentProps } from './SettingsContent';
import withPresenter from './SettingsContent.presenter';
import withInteractor from './SettingsContent.interactor';

export type { SettingsContentProps };
export default withInteractor(withPresenter(SettingsContent));
